export const {
  PUBLIC_URL,
  REACT_APP_ACCESS_TOKEN_NAME,
  REACT_APP_AFTER_SALE_CONDITIONS,
  REACT_APP_API_BASE_URL,
  REACT_APP_BASE_URL,
  REACT_APP_CONVENIOSMARCO_URL,
  REACT_APP_ENVIRONMENT,
  REACT_APP_FEATURE_FLAG_SHOW_HOME,
  REACT_APP_GOOD_PRACTICES_MANUAL_URL,
  REACT_APP_GOOGLE_ANALYTICS_KEY,
  REACT_APP_GOOGLE_TASK_MANAGER_KEY,
  REACT_APP_HOTJAR_ID,
  REACT_APP_HOTJAR_SNIPPET_VERSION,
  REACT_APP_MERCADOPUBLICO_URL,
  REACT_APP_LATAM_URL,
  REACT_APP_SKY_URL,
  REACT_APP_JETSMART_URL
} = process.env
export const isDevEnv = process.env.REACT_APP_ENVIRONMENT !== 'prod'
export const isLocalEnv = process.env.REACT_APP_ENVIRONMENT === 'local'
